export default __webpack_public_path__ + "static/media/Gas Bottle.42474a06.svg";